import React, { FC, memo } from 'react';
import styles from '@/styles/components/latest-article.module.scss';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import LazyImage from '@/components/common/lazy-image';
import dayJs from 'dayjs';
import { shallowEqual, useSelector } from 'react-redux';
import { AppState } from '@/store';
import Image from 'next/image';
import Link from 'next/link';
import placeholder from '@/public/img/PlaceholderImage.png';
import NextImage from 'next/image';

type Props = {
  className?: string;
  isHide?: boolean;
  onClick?: () => void;
  latestArticle?: any;
  h3Title?: boolean;
  lazyImage?: boolean;
};

const LatestArticle: FC<Props> = memo(
  ({ className, isHide, onClick, latestArticle, h3Title, lazyImage }: any) => {
    const router = useRouter();
    const { language } = useSelector(
      (state: AppState) => ({
        language: state.homePage.language
      }),
      shallowEqual
    );

    const pageData = latestArticle || {};
    const blogSnippet = pageData.blog_snippet || {};
    const category = blogSnippet.category || [];

    const goToArticle = async (category: string, articleUrl: string) => {
      let article = articleUrl;
      if (!/^\/.*/.test(article)) {
        article = '/' + article;
      }
      window?.dataLayer?.push({
        event: 'buttonClick',
        buttonTitle: 'related_article',
        description: blogSnippet.blog_title,
        destinationUrl: `/${language.origin}/blog/${category}${article}`,
        pageURL: window.location.href,
        componentName: 'related article'
      });
    };

    const categoryUrl = category[0]?.url ? category[0]?.url.replace(/\/([^/]+)\//, '$1') : '';
    const articleUrl = `/${language.origin}/blog/${categoryUrl}${pageData?.url}`;

    let totalTags = [];
    totalTags = blogSnippet?.topic_tags?.length > 0 ? [...blogSnippet?.topic_tags] : [];
    totalTags =
      blogSnippet?.product_tags?.length > 0
        ? [...totalTags, ...blogSnippet?.product_tags]
        : [...totalTags];

    return (
      <Link
        href={articleUrl}
        onClick={() => goToArticle(category[0]?.url, pageData?.url)}
        className={classNames(styles.Latest_Article, className)}
      >
        <div className={styles.Image_Container}>
          {lazyImage ? (
            <LazyImage
              src={blogSnippet.banner_mobile?.url}
              className={styles.Image}
              alt={blogSnippet.banner_alt_tag}
              width={'100%'}
              height={'100%'}
            />
          ) : (
            <NextImage
              loading="eager"
              src={blogSnippet.banner_mobile?.url || placeholder}
              className={styles.Image}
              alt={blogSnippet.banner_alt_tag}
              width={392.66}
              height={236}
            />
          )}
        </div>
        <div
          className={classNames(styles.Article_Element, { [styles.Hide_Article_Element]: !isHide })}
        >
          <div className={styles.Category_Date_Rate}>
            <div className={styles.Category}>
              <span>{blogSnippet.category?.length > 0 && blogSnippet.category[0]?.title}</span>
            </div>
            <div className={styles.Date_Rate}>
              <div className={styles.Date}>
                <Image
                  src="/blog/icon/Calendar.svg"
                  className={styles.Calendar}
                  alt={''}
                  width={12}
                  height={12}
                />
                {language.origin === 'zh' ? (
                  <span>
                    {dayJs(pageData.blog_snippet.last_update_date).format('YYYY年M月D日')}
                  </span>
                ) : (
                  <span>{dayJs(pageData.blog_snippet.last_update_date).format('D MMM YYYY')}</span>
                )}
              </div>
              <div className={styles.Rating}>
                <Image
                  src="/blog/icon/Star.svg"
                  className={styles.Star}
                  alt={''}
                  width={13}
                  height={12}
                />
                <span>
                  {blogSnippet.blog_rating && blogSnippet.blog_rating < 5
                    ? blogSnippet.blog_rating?.toFixed(1)
                    : '5.0'}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.Tags_Wrap}>
            {h3Title ? (
              <h3 className={styles.Title}>{blogSnippet.blog_title}</h3>
            ) : (
              <h4 className={styles.Title}>{blogSnippet.blog_title}</h4>
            )}
            {isHide && <p className={styles.Content}>{blogSnippet.description}</p>}
            <div className={styles.Tags}>
              {totalTags.length <= 8
                ? totalTags.map((item: any, index: number) => (
                    <span key={index} className={styles.Tag}>
                      {item?.title}
                    </span>
                  ))
                : totalTags.slice(0, 8).map((item: any, index: number) => (
                    <span key={index} className={styles.Tag}>
                      {item?.title}
                    </span>
                  ))}
              {/* {blogSnippet.topic_tags?.length > 0 && blogSnippet.topic_tags[0]?.title ? (
                <span className={styles.Tag}>{blogSnippet.topic_tags[0].title}</span>
              ) : (
                ''
              )}
              {blogSnippet.product_tags?.length > 0 && blogSnippet.product_tags[0]?.title ? (
                <span className={styles.Tag}>{blogSnippet.product_tags[0].title}</span>
              ) : (
                ''
              )} */}
            </div>
          </div>
        </div>
      </Link>
    );
  }
);

export default LatestArticle;
